export default __webpack_public_path__ + "static/ro_unit_w.59efcc6fbfc3d59af99ce7785b735855.png";